import { FC } from 'react';

import styles from './ScrollPrompt.module.css';
import Icon from '../Icon/Icon';

interface ScrollPromptProps {
  targetId: string;
  label: string;
  className?: string;
  showIcon?: boolean;
}

const ScrollPrompt: FC<ScrollPromptProps> = ({
  targetId,
  label,
  className = '',
  showIcon = false,
}) => {
  const handleClick = () => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`${styles.scrollPrompt} ${className}`}
      aria-label={label}
      type="button"
    >
      <span className={styles.text}>{label}</span>
      {showIcon && (
        <Icon
          className={styles.icon}
          icon="mdi:chevron-down"
          size="md"
          aria-hidden={true}
          aria-label="Scroll down"
        />
      )}
    </button>
  );
};

export default ScrollPrompt;
